/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  GetMonitorStatsQueryResponse,
  GetMonitorStatsPathParams,
  GetMonitorStatsQueryParams,
  GetMonitorStats401,
  GetMonitorStats404,
} from '../types/GetMonitorStats.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetMonitorStatsUrl(id: GetMonitorStatsPathParams['id']) {
  const res = { method: 'GET', url: `/v1/monitors/${id}/stats` as const };
  return res;
}

/**
 * @summary Get uptime statistics for a monitor
 * {@link /v1/monitors/:id/stats}
 */
export async function getMonitorStats(
  id: GetMonitorStatsPathParams['id'],
  params?: GetMonitorStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetMonitorStatsQueryResponse, ResponseErrorConfig<GetMonitorStats401 | GetMonitorStats404>, unknown>({
    method: 'GET',
    url: getGetMonitorStatsUrl(id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
